// Global permission definitions
export const PERMISSIONS = {
  DISPUTE_READ: 'dsp:r',
  DISPUTE_WRITE: 'dsp:w',
  DISPUTES_ALL_COMPANIES: 'cmpns:dsp',
  DISPUTES_CSV: 'dsp:csv',
  DISPUTES_ASSIGN: 'dsp:asgn',
  DISPUTE_DELETE_FILE: 'dsp:del:file',
  DISPUTE_EVIDENCE: 'dsp:evd',
  DISPUTE_EVIDENCE_SUBMIT: 'dsp:evd:sbmt', // gates the PayPal inquiries page while it is piloted with a few agents
  DASHBOARD: 'dshbrd',
  COMPANIES_WRITE_ALL: 'cmpn:w:all',
  COMPANIES_READ_ALL: 'cmpn:r:all',
  ACCOUNTS_OWN: 'acct:own',
  ADMIN_PANEL: 'adm:pnl',
  EVIDENCE_ACTIVITY: 'adm:evact',
  PAYMENT_SEARCH: 'pmnt:srch',
  ALERTS_OWN: 'alrt:own',
  ALERTS_ALL: 'alrt:all',
  ALERTS_ASSIGN: 'alrt:asgn',
  ALERTS_SETTINGS: 'alrt:sttngs',
  ALERTS_CSV: 'alrt:csv',
  ALERT_MERCHANT_TO_COMPANY: 'alrt:cmpn',
  BILLING_ALL: 'bll:all',
  BILLING_OWN: 'bll:own',
  OI_ALL: 'oi:all',
  OI_OWN: 'oi:own',
  ENROLMENT_READ_ALL: 'enrl:r:all',
  ENROLMENT_WRITE_ALL: 'enrl:w:all',
  ENROLMENT_OWN: 'enrl:own',
  API_KEYS_ALL: 'apikey:all',
  API_KEYS_OWN: 'apikey:own',
  VAMP_RATES_ALL: 'vamp:all',
  VAMP_RATES_OWN: 'vamp:own',
  REPORTS_ALL: 'rpt:all',
  REPORTS_OWN: 'rpt:own',
};
